// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__9WiBC","header":"ReportDetails_header__3CzGG","title":"ReportDetails_title__3Auh9","left":"ReportDetails_left__2e0Jn"};